import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { DateValue } from '@web/utils';

@Component({
  selector: 'app-date',
  imports: [CommonModule, DateFormatPipe],
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
})
export class DateComponent {
  @Input() public date!: DateValue;
}
